import React from 'react'
import { Percent, Lock, CheckCheck } from 'lucide-react'
import { toGO } from '../navBar'

const Features = () => {
  const features = [
    {
      icon: <Percent className='w-6 h-6 text-blue-600' />,
      title: 'Transparent & low fees',
      description: "With trading fees ranging from 0.00% to 0.25%, Bitvavo's fees are among the lowest in the industry."
    },
    {
      icon: <Lock className='w-6 h-6 text-blue-600' />,
      title: 'Security & account guarantee',
      description:
        'Security is our top priority. In addition to the many security features available, the Bitvavo Account Guarantee may reimburse you for up to €100.000 in the event of losses due to unauthorized access to your account.'
    },
    {
      icon: <CheckCheck className='w-6 h-6 text-blue-600' />,
      title: 'Legal compliance',
      description: 'Bitvavo is registered with De Nederlandsche Bank (DNB) and has industry leading compliance protocols.'
    }
  ]

  return (
    <div className='px-4 md:px-6 max-w-7xl mx-auto'>
      <div className='flex flex-col md:flex-row md:gap-16 md:items-center'>
        {/* Left Section - Deposit Interface - Hidden on Mobile */}
        <div className='hidden md:block md:w-1/3'>
          <img
            src='https://media.graphassets.com/output=format:avif/3a3JKfopSsOw1FHX8TLv'
            alt='Deposit Interface'
            className='w-full h-auto'
          />
        </div>

        {/* Right Section - Features */}
        <div className='md:w-2/3 space-y-8 md:space-y-12'>
          {features.map((feature, index) => (
            <div key={index} className='flex gap-4 md:gap-6' onClick={toGO}>
              <div className='flex-shrink-0'>
                <div className='w-12 h-12 flex items-center justify-center rounded-full bg-blue-50'>{feature.icon}</div>
              </div>
              <div>
                <h3 className='text-xl md:text-2xl font-semibold mb-2'>{feature.title}</h3>
                <p className='text-gray-600 text-lg'>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Features
